import React from "react";
import {Box, Typography} from '@mui/material';

const View = () => {
   return  (
      <Box sx={{pb: 3}}>
         <Typography
            component='h3'
            sx={{
               textAlign: 'center',
               color: 'success.main',
               fontSize: '3rem',
               my: 5,
            }}
         >
            Отличная работа!
         </Typography>
         <Typography sx={{textAlign: 'center'}}>Ты набрал нужное количество баллов и успешно завершил этот урок. Обязательно применяй полученные знания на практике, чтобы тренировать навык.</Typography>
      </Box>
   );
}

export default View;